import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";
import {
  GET_LOCATION_MASTER_DATA,
  PUT_VEHICLE_REPORT,
  LOCATIONS_STATUS_INACTIVE,
  LOCATIONS_STATUS_ACTIVE,
  SAVE_LOCATION_MASTER_WITH_LOGO,
  UPLOAD_FILE,
  UPDATE_FILE,
} from "../../../services/apiUrls";
import { get, post, Put } from "../../../services/service";
import axios from "axios";
import toast from "react-hot-toast";

export function useLocationMaster() {
  const [locationData, setLocationData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const [open, setOpen] = useState(false);
  const [searchValue, setSearchvalue] = useState("");
  const [buttonHandle, setButtonHandle] = useState("");
  const [files, setFiles] = useState({
    logo: "",
  });

  let tenantId = localStorage.getItem("tenantId");
  let locationId = localStorage.getItem("locationId");

  const isDisabled =
    selectedRow?.vehicletype !== "" && selectedRow?.description !== "";

  const fetchLocationMaster = async () => {
    const url = `${GET_LOCATION_MASTER_DATA.replace(
      "{tenantId}",
      tenantId
    ).replace("{locationId}", locationId)}`;
    const resp = await get(url);
    setLocationData(resp);
  };

  const handleChange = (event) => {
    setSelectedRow({ ...selectedRow, [event.target.name]: event.target.value });
  };

  const handleClickOpen = () => {
    setOpen(true);
    setButtonHandle("Add");
    handleClear();
  };

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleSearchChange = (e) => {
    setSearchvalue(e.target.value);
  };

  const fileUpload = (file, mediaId) => {
    return new Promise(async (resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);
      try {
        let resp;
        if (mediaId) {
          formData.append("mediaUrl", mediaId);
          resp = await Put(UPDATE_FILE, formData);
        } else resp = await post(UPLOAD_FILE, formData);
        if (resp.mediaUrl) resolve(resp.mediaUrl);
        else reject("Media not uploaded");
      } catch (err) {
        reject(err);
      }
    });
  };

  const handleSave = async () => {
    const url = `${SAVE_LOCATION_MASTER_WITH_LOGO.replace(
      "{tenantId}",
      tenantId
    ).replace("{locationId}", locationId)}`;

    try {
      const submitData = {
        ...selectedRow,
        tenantId,
        addressId: "167124a5-85f9-4423-a701-965e7d78fe6f",
      };

      if (Array.isArray(files.logo)) {
        const imageUrl = await fileUpload(files.logo[0]);
        submitData.imageUrl = imageUrl;
      }

      const resp = await post(url, submitData);
      if (resp && resp.id !== "") {
        fetchLocationMaster();
        toast.success("Location added successfully");
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = (row) => {
    const content = row.hiddenMeta;
    setSelectedRow(content);
    if (content.imageUrl)
      setFiles({
        logo: content.imageUrl,
      });
    setOpen(true);
    setButtonHandle("Edit");
  };

  const handleSaveEdit = async () => {
    const url = `${SAVE_LOCATION_MASTER_WITH_LOGO.replace(
      "{tenantId}",
      tenantId
    ).replace("{locationId}", locationId)}`;

    try {
      const submitData = {
        ...selectedRow,
        tenantId,
        addressId: "167124a5-85f9-4423-a701-965e7d78fe6f",
      };

      if (Array.isArray(files.logo)) {
        const imageUrl = await fileUpload(files.logo[0], selectedRow.imageUrl);
        submitData.imageUrl = imageUrl;
      }

      const resp = await Put(url, submitData);
      if (resp && resp.id !== "") {
        fetchLocationMaster();
        toast.success("Location updated successfully");
      }
      setOpen(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClear = () => {
    setSelectedRow({
      name: "",
      description: "",
      upiId: "",
      gstNo: "",
      address: "",
    });
    setFiles({
      logo: "",
    });
  };

  const toggleStatus = (id) => {
    const updatedData = locationData.map((row) =>
      row.id === id
        ? { ...row, deleted: row.deleted === false ? "ACTIVE" : "INACTIVE" }
        : row
    );
    setLocationData(updatedData);
  };

  const filteredRows =
    locationData?.length === 0 || locationData?.length === undefined
      ? []
      : locationData.filter(
          (row) =>
            row.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            row.description.toLowerCase().includes(searchValue.toLowerCase())
        );

  const columns = [
    {
      field: "id",
      headerName: "NO",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "name",
      headerName: "NAME",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },

    {
      field: "description",
      headerName: "DESCRIPTION",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "active",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Box display={"flex"} paddingRight={1}>
          <Button
            onClick={() => {
              toggleStatus(params.row.id);
            }}
          >
            {params?.row?.deleted === false ? (
              <Button
                variant="contained"
                size="small"
                color="success"
                sx={{ width: "2rem" }}
                onClick={() => {
                  locationStatusInactive(params.row.key);
                }}
              >
                <Typography sx={{ fontSize: "10px" }}>Active</Typography>
              </Button>
            ) : (
              <Button
                variant="contained"
                size="small"
                color="error"
                sx={{ width: "2rem" }}
                onClick={() => {
                  locationStatusActive(params.row.key);
                }}
              >
                <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
              </Button>
            )}
          </Button>
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params) => {
        return (
          <EditIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
              window.scrollTo(0, 0);
              handleEdit(params.row);
            }}
          />
        );
      },
      // renderCell: (params) => (
      //   <Box display="flex" justifyContent="center">
      //     <IconButton onClick={() => handleEdit(params.row)}>
      //       <Edit />
      //     </IconButton>
      //   </Box>
      // ),
    },
  ];

  // LOCATION STATUS INACTIVE
  const locationStatusInactive = async (id) => {
    try {
      const resp = await axios
        .delete(
          LOCATIONS_STATUS_INACTIVE.replace("{tenantId}", tenantId).replace(
            "{id}",
            id
          )
        )
        .then((res) => {
          fetchLocationMaster();
          return res;
        });
      return resp;
    } catch (err) {
      return err;
    }
  };

  // LOCATION STATUS ACTIVE
  const locationStatusActive = async (id) => {
    try {
      const resp = await axios
        .delete(
          LOCATIONS_STATUS_ACTIVE.replace("{tenantId}", tenantId).replace(
            "{id}",
            id
          )
        )
        .then((res) => {
          fetchLocationMaster();
          return res;
        });
      return resp;
    } catch (err) {
      return err;
    }
  };

  const rows = filteredRows.map((rowData, index) => ({
    key: rowData.id,
    id: index + 1,
    name: rowData.name,
    description: rowData.description,
    status: rowData?.status,
    deleted: rowData.deleted,
    hiddenMeta: { ...rowData },
  }));

  /*eslint-disable */
  useEffect(() => {
    fetchLocationMaster();
  }, []);
  /*eslint-enable */

  return {
    files,
    setFiles,
    locationData,
    selectedRow,
    open,
    searchValue,
    buttonHandle,
    isDisabled,
    fetchLocationMaster,
    handleChange,
    handleClickOpen,
    handleClose,
    handleSearchChange,
    handleSave,
    handleEdit,
    handleSaveEdit,
    toggleStatus,
    handleClear,
    columns,
    rows,
  };
}
